import Vue from 'vue';

import resources from '@/assets/locales/resources';

const i18nPluginCustom = {
  install(vue, options) {
    const { fallbackLng, resources } = options;
    const languageObj = resources[fallbackLng]?.tjt_operation_web;
    vue.prototype.$getText = function (textKey, config) {
      if (typeof config === 'object') {
        if (config.hasOwnProperty('pluralCount')) {
          const oneReg = /one \{(.*?)\}/;
          const otherReg = /other \{(.*?)\}/;
          const one = languageObj[textKey]?.match(oneReg);
          const other = languageObj[textKey]?.match(otherReg);
          if (fallbackLng === 'zh') {
            return other?.[1];
          }
          return config.pluralCount > 1 ? other?.[1] : one?.[1];
        } else {
          const regex = new RegExp(`\\{(${Object.keys(config).join('|')})\\}`, 'g');
          return languageObj[textKey]?.replace(regex, (_, key) => config[key]) || '';
        }
      } else {
        return languageObj[textKey] || config;
      }
    };
    vue.prototype.$i18nClient = {
      getCurrentLocale() {
        return fallbackLng;
      },
    };
  }
};

let language = window.navigator.language;
language = language.toLowerCase();
let current_language = 'zh';
if (language === 'zh-CN' || language === 'zh' || language.indexOf("zh-") === 0) {
  current_language = "zh";
} else {
  current_language = "en";
}

Vue.use(i18nPluginCustom, {
  resources,
  fallbackLng: current_language,
});

const i18nInstance = new Vue();
export const getText = (key, config) => i18nInstance.$getText(key, config);
